import { TLCode } from './enums';
import { FormError, Translate, Validate } from '../typings/typings';

export const makeValidate = (fns) => (value): FormError[] => {
  const errors = fns.map((f) => f(value)).filter(Boolean);
  return errors.length ? errors : [];
};

export const createGetErrorText = (translate: Translate) => (error: FormError) => {
  // FormError
  if (typeof error === 'object') {
    return translate(error.id, error.values);
  }
  // TLCode
  if (typeof error === 'number') {
    return translate(error);
  }
  // String
  return error;
};

export const notEmpty: Validate = (value) => (value == null || value === '' ? TLCode.ERROR_REQUIRED_FIELD : undefined);

export const lengthLessThan = (length: number): Validate => (value) =>
  value && value.length > length
    ? {
        id: TLCode.ERROR_VALUE_TOO_LONG,
        values: {
          length,
        },
      }
    : undefined;

const toArray = (value) => (Array.isArray(value) ? value : [value]);

export const mustMatchRegex = (regex: string, tlCode = TLCode.FORM_FIELD_VALIDATION_REGEX): Validate => (value) => {
  return value && toArray(value).some((word) => !new RegExp(regex).test(word))
    ? {
        id: tlCode,
        values: {
          regex,
        },
      }
    : undefined;
};
